module.exports = __webpack_public_path__ + "9177e40d7b6bb170132e5292bf019c49.svg";